<div [ngClass]="setClasses()">
  <p>
    <input type="checkbox" [checked]="todo.completed" (change)="toggle(todo)" />
    {{ todo.title }}
    <button class="del" (click)="destroy(todo)">X</button>
  </p>
</div>
